import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import Growing_tray_for_microgreens1 from "../../Assets/Growing tray for microgreens or Fodder tray1.webp";
import Growing_tray_for_microgreens2 from "../../Assets/Growing tray for microgreens or Fodder tray2.webp";
import Growing_tray_for_microgreens3 from "../../Assets/Growing tray for microgreens or Fodder tray3.webp";
import Growing_tray_for_microgreens4 from "../../Assets/Growing tray for microgreens or Fodder tray4.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tab, Nav, Carousel } from "react-bootstrap";
import "../../App.css";

const Growing_tray_for_microgreens_shop = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 60,
      name: "Twisted Rope (Tensioning Rope)",
      price: 250,
      image: Growing_tray_for_microgreens1,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Growing_tray_for_microgreens1}
                alt="growing tray"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Growing_tray_for_microgreens2}
                alt="growing tray for microgreens"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Growing_tray_for_microgreens3}
                alt="fodder tray"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Growing_tray_for_microgreens4}
                alt="microgreen tray"
              />
            </Carousel.Item>
          </Carousel>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">
              Growing tray for microgreens/Fodder tray
            </h2>
            <p className="product-price">
              <a href="/Contact" className="btn btn-link">
                Contact Us for Price Details
              </a>
            </p>

            {/* <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button> */}

            <div className="row mt-4">
              <div className="col-12">
                <p className="text-justify">
                  <h4>
                    Efficient Germination & Growth Platform for Microgreens and
                    Animal Fodder
                  </h4>
                  Specially designed for high-density seed germination and
                  fast-growing crops, these trays are ideal for microgreens,
                  wheatgrass, and animal fodder. Made from durable, food-grade
                  plastic, they provide optimal drainage and aeration to ensure
                  healthy root development without waterlogging or rot.
                </p>
                <i>Note: Minimum Order Quantity: 50 Trays</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section with Border */}
      <div className="row mt-4">
        <div className="col-12 border-tabs">
          <Tab.Container defaultActiveKey="Specifications">
            <Nav variant="tabs" className="mb-3 custom-nav">
              <Nav.Item>
                <Nav.Link eventKey="Specifications" className="custom-tab">
                  Product Specifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Features" className="custom-tab">
                  Features
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="moreInfo" className="custom-tab">
                  Additional Information
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Specifications">
                <ul>
                  <li>
                    <span className="fw-bold">Material:</span> High-strength,
                    UV-stabilized food-grade plastic
                  </li>
                  <li>
                    <span className="fw-bold">Dimensions:</span> 20” x 10” x
                    1.25” (standard) or customizable sizes available
                  </li>
                  <li>
                    <span className="fw-bold">Design:</span> Grooved base for
                    even water flow and aeration
                  </li>
                  <li>
                    <span className="fw-bold">Drainage holes:</span> Optional
                    depending on crop type
                  </li>
                  <li>
                    <span className="fw-bold">Reusability:</span> Designed for
                    multiple growing cycles
                  </li>
                  <li>
                    <span className="fw-bold">Weight capacity:</span> Can
                    support dense microgreen mats and fodder sprouts
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="Features">
                <h4>Features</h4>
                <ul>
                  <li>
                    Scalable: Great for both small growers and large-scale
                    operations
                  </li>
                  <li>
                    Efficient water use: Encourages moisture retention with
                    minimal waste
                  </li>
                  <li>Clean Growth Environment: Easy to sanitize and reuse</li>
                  <li>
                    Modular Design: Compatible with vertical farming and rack
                    systems
                  </li>
                  <li>
                    Strong Build: Weather-resistant plastic ensures long-term
                    durability
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="moreInfo">
                <h4>Additional Information</h4>
                <ul>
                  <li>
                    <span className="fw-bold">Item Code:</span> RGCPL-0039
                  </li>
                  <li>
                    <span className="fw-bold">Delivery Time:</span> 7-8 Days
                  </li>
                  <li>
                    <span className="fw-bold">Port of Dispatch:</span>{" "}
                    Maharashtra, India
                  </li>
                  <li>
                    <span className="fw-bold">Production Capacity:</span> 2,000+
                    Trays Per Day
                  </li>
                  <li>
                    <span className="fw-bold">Packaging Details:</span>{" "}
                    Corrugated boxes or custom-packed as per request
                  </li>
                  <li>
                    <span className="fw-bold">Payment Terms:</span> Advance
                    Payment
                  </li>
                  <li>
                    <span className="fw-bold">Payment Mode:</span> RTGS / NEFT /
                    IMPS
                  </li>
                </ul>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <h5 className="mt-3">Key Benefits:</h5>
        <ul>
          <li>Fast Germination: Supports quick and uniform seed sprouting</li>

          <li>Excellent Drainage & Aeration: Prevents mold and root rot</li>

          <li>Strong Build: Doesn’t warp, crack, or degrade with use</li>

          <li>Stackable Design: Space-efficient storage and use</li>

          <li>
            Multi-Purpose: Suitable for home, greenhouse, or commercial setups
          </li>
        </ul>

        <h5 className="mt-3">Applications:</h5>
        <ul>
          <li>
            Commercial Microgreens Production – Ideal for growing crops like
            wheatgrass, basil, radish, mustard, and sunflower.
          </li>

          <li>
            Fodder Farming Systems – Used for sprouting barley, maize, and other
            grains for animal fodder.
          </li>

          <li>
            Home & Rooftop Gardening – Perfect for small-scale indoor or balcony
            setups.
          </li>

          <li>
            Vertical Farming Units – Compatible with rack-based or multi-level
            farming structures.
          </li>
          <li>
            Hydroponic & Soil-Based Germination – Suitable for both systems with
            or without media.
          </li>
          <li>
            Educational Institutions & Research Labs – Used for plant science
            demonstrations and controlled trials.
          </li>
        </ul>
      </div>

      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Growing_tray_for_microgreens_shop;
